module.exports = __webpack_public_path__ + "static/media/Poppins-Semibold-latin.a09f2fcc.woff2";